// src/api/services/notifications.js
import apiClient from '../client';

export const notificationService = {
    getSettings: () => apiClient.get('/api/notifications/settings'),
    updateSettings: (settings) => apiClient.put('/api/notifications/settings', settings),
    testNotification: (channel) => apiClient.post('/api/notifications/test', { channel }),
};